var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('CommonSnackBar',{attrs:{"objects":_vm.objects},on:{"update:objects":function($event){_vm.objects=$event}}}),_c('CommonLoader',{attrs:{"loadingMessage":_vm.loaderMessage,"showOverlay":_vm.showLoader}}),_c('ConfirmationDialog',{ref:"confirmationDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }